import { api } from "./api";
import { setTokens, getToken } from "./authToken";

const ORIG = "rc_orig_token";
const ACTIVE = "rc_test_role";

export const activeTestRole = () => {
  try { return sessionStorage.getItem(ACTIVE); } catch { return null; }
};

// Switch the session into a seeded test account (System Admin only).
export async function switchToTestRole(role) {
  const orig = getToken();
  try { sessionStorage.setItem(ORIG, orig || ""); } catch (e) { console.debug("switchToTestRole: storage unavailable", e); }
  const { data } = await api.post("/auth/switch-role", { role });
  setTokens({ access_token: data.access_token, remember: false });
  try { sessionStorage.setItem(ACTIVE, data.user.role); } catch (e) { console.debug("switchToTestRole: storage unavailable", e); }
  window.location.href = (data.user.role === "public" || data.user.role === "language_interpreter") ? "/portal" : "/admin";
}

// Restore the original System Admin session.
export function returnFromTestRole() {
  let orig = null;
  try {
    orig = sessionStorage.getItem(ORIG);
    sessionStorage.removeItem(ORIG);
    sessionStorage.removeItem(ACTIVE);
  } catch (e) { console.debug("returnFromTestRole: storage unavailable", e); }
  if (orig) setTokens({ access_token: orig, remember: false });
  window.location.href = "/admin";
}
